"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultGroupColor = getDefaultGroupColor;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _groupBy = _interopRequireDefault(require("lodash/groupBy"));

var _toArray3 = _interopRequireDefault(require("lodash/toArray"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _react = _interopRequireWildcard(require("react"));

var _md = _interopRequireDefault(require("md5.js"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@emcasa/ui/lib/styles");

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _Row = _interopRequireDefault(require("../Row"));

var _Col = _interopRequireDefault(require("../Col"));

var _Text = _interopRequireDefault(require("../Text"));

var _Input = _interopRequireDefault(require("./Input"));

var _Button = _interopRequireWildcard(require("./Button"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  align-items: center;\n  flex-wrap: wrap;\n  overflow-y: auto;\n  min-height: ", ";\n  ", ";\n  padding-top: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MIN_LUMINANCE = 0.15;
var MAX_LUMINANCE = 0.4;
var Label = (0, _styledComponents["default"])(_Row["default"])(_templateObject(), function (props) {
  return (0, _styles.buttonHeight)(props).height;
}, function (props) {
  return props.maxRows && {
    maxHeight: "".concat(parseInt((0, _styles.buttonHeight)(props).height) * props.maxRows - _Button.tagVerticalMargin, "px")
  };
}, _Button.tagVerticalMargin);

function getDefaultGroupColor(group) {
  if (!group) return undefined;
  var hex = "#".concat(new _md["default"]().update(group).digest('hex').slice(0, 6));
  var color = (0, _tinycolor["default"])(hex);
  var luminance = color.getLuminance();
  if (luminance < MIN_LUMINANCE) color.brighten((MIN_LUMINANCE - luminance) * (1 - luminance) * 100);
  if (luminance > MAX_LUMINANCE) color.darken((luminance - MAX_LUMINANCE) * luminance * 100);
  return color.toHexString();
}

var isTag = function isTag(tag) {
  return function (t) {
    return t.name === tag.name;
  };
};

var selectStrategy = {
  getInitialValue: _toArray3["default"],
  isSelected: function isSelected(selectedValue, tag) {
    return tag && selectedValue.find(isTag(tag));
  },
  update: function update(_ref, tag) {
    var _ref2 = (0, _toArray2["default"])(_ref),
        selectedValue = _ref2.slice(0);

    var index = selectedValue.findIndex(isTag(tag));
    if (index === -1) selectedValue.push(tag);else selectedValue.splice(index, 1);
    return selectedValue;
  }
};

var TagInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(TagInput, _PureComponent);

  function TagInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, TagInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(TagInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "inputRef", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (values) {
      if (_this.props.onChange) _this.props.onChange(values);

      _this.setState({
        values: values
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDelete", function (value) {
      _this.onChange(_this.state.values.filter(function (val) {
        return val !== value;
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeText", function (search) {
      if (_this.props.onChangeText) _this.props.onChangeText(search);

      _this.setState({
        search: search,
        focus: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function () {
      return _this.setState({
        focus: true
      }, _this.props.onFocus);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function () {
      return _this.setState({
        focus: false,
        search: ''
      }, _this.props.onBlur);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickButton", function () {
      setTimeout(function () {
        if (_this.inputRef.current) {
          _this.inputRef.current.focus();
        }
      }, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderTag", function (value, index) {
      var _this$props = _this.props,
          getKey = _this$props.getKey,
          renderTag = _this$props.renderTag,
          height = _this$props.height;
      var key = getKey(value, index);
      if (renderTag) renderTag(value, key);
      if (_this.props.renderTag) _this.props.renderTag(value, key);
      return _react["default"].createElement(_Button["default"], {
        key: key,
        active: true,
        group: _this.getGroup(value),
        color: _this.getTagColor(value),
        height: height,
        onDelete: function onDelete() {
          return _this.onDelete(value);
        }
      }, value.name);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderOption", function (value, index) {
      var _this$props2 = _this.props,
          getKey = _this$props2.getKey,
          renderOption = _this$props2.renderOption,
          height = _this$props2.height;
      var key = getKey(value, index);
      if (renderOption) renderOption(value, key);
      return _react["default"].createElement(_Button["default"], {
        key: key,
        value: value,
        height: height,
        color: _this.getTagColor(value)
      }, value.name);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPaste", function (e) {
      var pastedText = e.clipboardData.getData('Text');
      var pastedItems = pastedText.split(';');

      if (pastedItems.length > 0) {
        var newValues = JSON.parse(JSON.stringify(_this.state.values));
        pastedItems.forEach(function (item) {
          var tagFound = _this.getTag(item, _this.props.options);

          var isDuplicate = _this.isDuplicate(tagFound, newValues);

          if (tagFound && !isDuplicate) {
            newValues.push(tagFound);
          }
        });

        _this.onChange(newValues);

        setTimeout(function () {
          _this.onChangeText('');

          _this.inputRef.current.value = '';
        }, 1000);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isDuplicate", function (tag, tags) {
      return tags.find(function (t) {
        return t.name.trim().toLowerCase() === tag ? tag.name.trim().toLowerCase() : '';
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTag", function (name, tags) {
      return tags.find(function (t) {
        return t.name.trim().toLowerCase() === name.trim().toLowerCase();
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(TagInput, [{
    key: "getGroup",
    value: function getGroup(tag) {
      if (typeof this.props.groupBy === 'function') return this.props.groupBy(tag);
      return tag[this.props.groupBy];
    }
  }, {
    key: "getGroupColor",
    value: function getGroupColor(group) {
      return this.props.getGroupColor && this.props.getGroupColor(group) || undefined;
    }
  }, {
    key: "getTagColor",
    value: function getTagColor(tag) {
      return this.props.getTagColor && this.props.getTagColor(tag) || this.getGroupColor(this.getGroup(tag));
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(options, group) {
      var children = options.map(this.renderOption);
      if (group) children.unshift(_react["default"].createElement(_Row["default"], {
        style: {
          boxSizing: 'border-box'
        },
        flex: "1 0 100%",
        mt: 2,
        mb: 2,
        pr: 2,
        pl: 2
      }, _react["default"].createElement(_Text["default"], {
        inline: true
      }, group)));
      return children;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this2 = this;

      var _this$props3 = this.props,
          onChangeText = _this$props3.onChangeText,
          placeholder = _this$props3.placeholder,
          height = _this$props3.height,
          labelProps = _this$props3.labelProps,
          renderLabel = _this$props3.renderLabel;
      var _this$state = this.state,
          values = _this$state.values,
          search = _this$state.search,
          focus = _this$state.focus;

      var input = _react["default"].createElement(_Col["default"], {
        flex: "1 0 150px"
      }, _react["default"].createElement(_Input["default"], {
        ref: this.inputRef,
        height: height,
        placeholder: placeholder,
        onChange: function onChange(e) {
          return _this2.onChangeText(e.target.value);
        },
        onPaste: this.onPaste,
        onMouseDown: function onMouseDown(e) {
          e.stopPropagation();
          if (!focus) setTimeout(_this2.onFocus, 0);
        },
        value: search
      }));

      var tags = values ? values.map(this.renderTag) : [];
      return _react["default"].createElement(Label, (0, _extends2["default"])({
        height: height
      }, labelProps), renderLabel ? renderLabel(values, {
        input: input,
        tags: tags
      }) : _react["default"].createElement(_react["default"].Fragment, null, tags, Boolean(onChangeText) && input));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          options = _this$props4.options,
          placeholder = _this$props4.placeholder,
          height = _this$props4.height,
          containerProps = _this$props4.containerProps,
          buttonProps = _this$props4.buttonProps,
          props = (0, _objectWithoutProperties2["default"])(_this$props4, ["children", "options", "placeholder", "height", "containerProps", "buttonProps"]);
      var _this$state2 = this.state,
          values = _this$state2.values,
          focus = _this$state2.focus;
      var optionsGroups = (0, _groupBy["default"])(options, this.props.groupBy);
      return _react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({
        focused: focus,
        strategy: selectStrategy,
        blurOnChange: false,
        icon: "tag",
        height: "auto",
        placeholder: placeholder,
        containerProps: (0, _deepmerge["default"])(_objectSpread({}, containerProps), {
          style: {
            flexDirection: 'row',
            flexWrap: 'wrap'
          }
        }),
        buttonProps: Object.assign(_objectSpread({}, buttonProps), {
          onClick: this.onClickButton
        }),
        iconProps: {
          height: height
        },
        label: this.renderLabel()
      }, props, {
        selectedValue: values,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }), _react["default"].createElement(_Row["default"], {
        flex: "1 0 100%"
      }, children), options && Object.entries(optionsGroups).map(function (_ref3) {
        var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
            group = _ref4[0],
            options = _ref4[1];

        return _this3.renderOptions(options, group);
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      return {
        values: props.selectedValue || state.values || props.initialValue || [],
        search: props.search || state.search || '',
        focus: typeof props.focused !== 'undefined' ? props.focused : state.focus
      };
    }
  }]);
  return TagInput;
}(_react.PureComponent);

exports["default"] = TagInput;
(0, _defineProperty2["default"])(TagInput, "propTypes", {
  initialValue: _propTypes["default"].arrayOf(_propTypes["default"].object),
  selectedValue: _propTypes["default"].arrayOf(_propTypes["default"].object),
  options: _propTypes["default"].arrayOf(_propTypes["default"].object),
  renderTag: _propTypes["default"].func,
  groupBy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  getKey: _propTypes["default"].func
});
(0, _defineProperty2["default"])(TagInput, "defaultProps", {
  height: 'medium',
  groupBy: 'category',
  getKey: function getKey(_, index) {
    return index;
  },
  getGroupColor: getDefaultGroupColor,
  labelProps: {}
});
(0, _defineProperty2["default"])(TagInput, "Option", _Dropdown["default"].Option);